import * as elements from './elements'

const reviver = (key, value) => {
  if (value !== null && typeof value === 'object' && '__TYPE__' in value) {
    // created an instance based on type name
    let instance = new elements[value.__TYPE__]()

    // don't need implicit type after deserialization
    // delete value.__TYPE__

    // repopulate object with json data
    return Object.assign(instance, value)
  } else {
    return value
  }
}

export default {
  // converts editor doc to json string
  serialize(doc) {
    return JSON.stringify(doc)
  },

  // converts json string to editor doc
  deserialize(json) {
    return JSON.parse(json, reviver)
  },

  // converts doc to POJO (plain old javascript object) with __TYPE__ fields
  hibernate(doc) {
    function recurse(obj) {
      if (Array.isArray(obj)) {
        return obj.map(item => recurse(item))
      } else if (typeof obj === 'object' && obj !== null) {
        let props = Object.entries(obj).reduce((acc, [key, value]) => {
          acc[key] = recurse(value)
          return acc
        }, {})

        return 'toJSON' in props ? props.toJSON() : props
      } else {
        return obj
      }
    }

    return recurse(doc)
  },

  // converts POJO (plain old javascript object) with __TYPE__ fields to editor doc
  revive(pojo) {
    function recurse(obj) {
      if (Array.isArray(obj)) {
        return obj.map(item => recurse(item))
      } else if (typeof obj === 'object' && obj !== null) {
        let props = Object.entries(obj).reduce((acc, [key, value]) => {
          acc[key] = recurse(value)
          return acc
        }, {})

        // no need to pass a key to reviver
        return reviver(null, props)
      } else {
        return obj
      }
    }

    return recurse(pojo)
  }
}
